const HeadingButtonForUpcomingId = (
  { Heading = "KYC History",
    upcomingCount = 0,
    expireCount = 0,
    moreInfoCount = 0,
    handleButtonClick,
    activeButton,
    showMoreInfo = false
  }) => {
  const getButtonClass = (content) => {
    return activeButton === content
      ? 'px-4 py-2 text-[#000000] font-[500] bg-[#00811D1A] rounded-md'
      : 'px-4 py-2 text-[#0F172ACC] font-[400] bg-white border border-gray-300 rounded-md';
  };

  return (
    <div className="flex flex-col md:items-center justify-between mb-6 md:flex-row">
      <h1 className="mb-4 text-2xl font-bold text-gray-800 md:mb-0">{Heading}</h1>
      <div className="flex flex-wrap justify-center gap-3 md:justify-start">
        <button
          className={getButtonClass('upcoming')}
          onClick={() => handleButtonClick('upcoming')}
        >
          Upcoming: {upcomingCount}
        </button>
        <button
          className={getButtonClass('expired')}
          onClick={() => handleButtonClick('expired')}
        >
          Expired: {expireCount}
        </button>

        {showMoreInfo && (
          <button
            className={getButtonClass('more-info')}
            onClick={() => handleButtonClick('more-info')}
          >
            More Info Required: {moreInfoCount}
          </button>
        )}
      </div>
    </div>
  )
}

export default HeadingButtonForUpcomingId
